import React from 'react';
import classes from './Landing.css';

const landing = ( props ) => {
    
    return (
        <div className={classes.Landing}>
            <div className="center-content">
                James Rainaldi &reg;
            </div>

            <a href="/japanese-practice.html">Japanese Practice App</a>
        </div>
    );
};

export default landing;


// WEBPACK FOOTER //
// ./src/components/Landing/Landing.js